<template>
  <div class="solutions-swiper-container">
    <div class="swiper-container" ref="solutionsSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in solutionsList" :key="index">
          <div class="solution-card" @click="handleProductClick(item)">
            <div class="solution-image">
              <img v-lazy="item.coverImg + '?x-oss-process=image/resize,w_300'" alt="yake">
              <div class="solution-title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 分页器和按钮区域 -->
      <div class="swiper-navigation">
        <div class="swiper-navigation-btn">
          <div class="swiper-button-prev">
            <img src="../assets/images/left.png" alt="" />
          </div>
          <div class="swiper-button-next">
            <img src="../assets/images/right.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import {pushWithLanguage} from "@/utils/routeUtils";

export default {
  name: 'SolutionsSwiper',
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      swiper: null,
      solutionsList: []
    }
  },
  created() {
    this.solutionsList = this.items
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  },
  methods: {
    handleProductClick(item) {
      if(item.targetUrl){
        pushWithLanguage('/'+item.targetUrl, this.currentLanguage).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error( err)
          }
        })
      }
    },
    
    initSwiper() {
      this.swiper = new Swiper(this.$refs.solutionsSwiper, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        centeredSlides: true,
        loop: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          480: {
            slidesPerView: 1.5,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 24
          }
        }
      });
    }
  },
  watch: {
    items: {
      handler(newVal) {
        this.solutionsList = newVal;
        this.$nextTick(() => {
          if (this.swiper) {
            this.swiper.destroy();
          }
          this.initSwiper();
        });
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped>
@import '../assets/styles/variables.less';
@import '../assets/styles/mixins.less';

.solutions-swiper-container {
  width: 100%;
  padding: 0 0 20px;

  .swiper-container {
    padding: 0 8px;
    overflow: visible;
  }

  .swiper-wrapper {
    display: flex;
    align-items: stretch;
  }

  .swiper-slide {
    width: 90vw;
    max-width: 340px;
    height: 220px;
    border-radius: 16px;
    background: #fff;
    overflow: hidden;
    margin-right: 12px;
    box-sizing: border-box;
    position: relative;
    transition: box-shadow 0.2s;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);

    &.swiper-slide-active {
      box-shadow: 0 4px 16px rgba(25,82,159,0.12);
      border-color: #19529F;
    }
  }

  .solution-card {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    background: #fff;

    .solution-image {
      width: 100%;
      height: 100%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 16px 16px 0 0;
      }

      .solution-title {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        padding: 24px 16px 16px;
        font-size: 18px;
        color: #fff;
        background: linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,0.7) 100%);

        border-radius: 0 0 16px 16px;
      }
    }
  }

  .swiper-bottom-bar {
    position: relative;
    margin-top: 32px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    .swiper-bottom-line {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      height: 1px;
      background: #e0e0e0;
      z-index: 1;
      transform: translateY(-50%);
    }

    .swiper-bottom-controls {
      position: relative;
      z-index: 2;
      display: flex;
      gap: 12px;
      justify-content: center;
      align-items: center;
    }

    .swiper-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 56px;
      height: 32px;
      border-radius: 16px;
      border: none;
      background: #fff;
      color: #19529F;
      font-size: 18px;
      box-shadow: 0 2px 8px rgba(25,82,159,0.08);
      position: relative;
      transition: background 0.2s, color 0.2s;

      &.active {
        background: #19529F;
        color: #fff;
      }

      .icon-arrow {
        font-size: 18px;
        margin-right: 4px;
        font-weight: bold;
      }
      .icon-box {
        display: inline-block;
        width: 16px;
        height: 16px;
        border: 1.5px dashed currentColor;
        border-radius: 3px;
        margin-left: 2px;
        vertical-align: middle;
      }
    }
  }

  .swiper-pagination {
    margin-top: 12px;
    text-align: center;
    .swiper-pagination-bullet {
      width: 8px;
      height: 8px;
      margin: 0 3px;
      background: #ddd;
      opacity: 0.7;
      border-radius: 50%;
      display: inline-block;
      &-active {
        background: #19529F;
        opacity: 1;
      }
    }
  }
}

</style>
